import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  AccountsConfigurationKeys,
  AccountsConfigurations,
  ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES,
  ACCOUNTS_FEATURE_NAME,
  selectConfigurationValueFrom,
  selectIsAccountAddressReverted,
} from '@epicuro-next/platform/configuration';
import { getFullShipToAddress } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { Account } from 'graphql-api/gql-api-interfaces';
import { Observable, of } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'epc-account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountInformationComponent implements OnInit {
  @Input() public account: Account;

  public accountAddresses$: Observable<
    { displayName: string; addressId: string }[]
  >;

  public readonly addressFields$ = this.store.pipe(
    select(
      selectConfigurationValueFrom<
        AccountsConfigurationKeys.AddressShownProperties,
        AccountsConfigurations
      >(
        ACCOUNTS_FEATURE_NAME,
        AccountsConfigurationKeys.AddressShownProperties,
        ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES[
          AccountsConfigurationKeys.AddressShownProperties
        ],
      ),
    ),
  );

  constructor(private store: Store) {}

  public ngOnInit() {
    this.accountAddresses$ = of(this.account.shipToAddresses).pipe(
      withLatestFrom(this.store.pipe(select(selectIsAccountAddressReverted))),
      map(([shipToAddresses, revertAddress]) => {
        return shipToAddresses.map((address) => ({
          displayName: getFullShipToAddress(address, {
            revertAddress,
            countryCodePreferred: true,
          }),
          addressId: address.realAddressId as string,
        }));
      }),
    );
  }
}
